import type { IconData } from '@stacksjs/iconify-core'

export const moonStarsSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M29 2.5A1.5 1.5 0 0 1 30.5 4v1.5H32a1.5 1.5 0 0 1 0 3h-1.5V10a1.5 1.5 0 0 1-3 0V8.5H26a1.5 1.5 0 0 1 0-3h1.5V4A1.5 1.5 0 0 1 29 2.5M18.228 19.47c0 7.669 6.217 13.885 13.885 13.885c1.12 0 2.21-.133 3.253-.383c.811-.195 1.595.54 1.272 1.31C33.988 40.579 27.76 45 20.5 45C10.835 45 3 37.165 3 27.5S10.835 10 20.5 10c.572 0 .85.68.506 1.138a13.82 13.82 0 0 0-2.778 8.333m20.096 7.934c-.261.795-1.386.795-1.648 0l-1.615-4.912a.87.87 0 0 0-.553-.553l-4.912-1.615c-.795-.262-.795-1.387 0-1.648l4.912-1.615a.87.87 0 0 0 .553-.553l1.615-4.912c.261-.795 1.386-.795 1.648 0l1.615 4.912a.87.87 0 0 0 .553.553l4.912 1.615c.795.262.795 1.387 0 1.648l-4.912 1.615a.87.87 0 0 0-.553.553z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default moonStarsSolid
